<template>
  <div
    class="game-cotrol-panel game-control-panel-border"
    :style="'left:' + pos.x + '%;top:' + pos.y + '%;'"
    :class="[{ 'demo-tr-game-control-panel': !demoDisableKey }]"
  >
    <tr-game-control-panel-button
      name="checkButton"
      title="Sprawdź"
      @eventType="checkGameStatus()"
    ></tr-game-control-panel-button>
    <tr-game-control-panel-button
      v-if="demoDisableKey"
      name="resolveButton"
      :disabled="true"
      title="Pokaż rozwiązanie
Opcja dostępna w pełnej wersji multibooka"
      :class="[{ 'disable-shadow': !demoDisableKey }]"
      @eventType="showCorrectAnswer()"
    ></tr-game-control-panel-button>
    <tr-game-control-panel-button
      name="resetButton"
      title="Rozwiąż jeszcze raz"
      @eventType="resetGame()"
    ></tr-game-control-panel-button>
  </div>
</template>

<script>
import TrGameControlPanelButton from './TrGameControlPanelButtom/TrGameControlPanelButtomV2';
export default {
  name: 'tr-game-control-panel-v2',
  components: {
    TrGameControlPanelButton,
  },
  props: {
    pos: {
      type: Object,
      default: function () {
        return !this.demoDisableKey ? { x: 90, y: 92.8 } : { x: 84.9, y: 92.8 };
      },
    },
  },
  mounted: function () {
    // // console.log('Control panel');
  },
  methods: {
    checkGameStatus() {
      // // console.log('checkGameStatus');
      // // console.log('changeGameStatus');
      // this.$emit('checkGame');
      this.$store.dispatch('checkGame');
      // this.$emit('changeGameStatus');
    },
    showCorrectAnswer() {
      // // console.log('showCorrect');
      // this.$emit('changeGameStatus');
    },
    resetGame() {
      // // console.log('resetGame');
      // let dataObj = this.$store.getters.gameData;
      this.$store.commit('RESET_GAME', true);
      // this.$emit('changeGameStatus');
    },
  },
  computed: {
    demoDisableKey() {
      return this.$store.getters.demoDisableKey;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/sass/iconColor';
.disable-shadow {
  opacity: 0.5;
  // pointer-events: none;
  cursor: not-allowed;
}
.game-cotrol-panel {
  position: absolute;
  width: 15%;
  height: 7%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.demo-tr-game-control-panel {
  width: 10%;
}
.game-control-panel-border {
  // border: solid 1px black;
  border-radius: 10px;
  background-color: $backgroundControlPanelColor;
}
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */
//
// .hack-game-very-specific-design {
//     top: 0 !important;
//     left: 0 !important;
//     // width: 1366px !important;
//     // height: 768px !important;
//     transform: translate(0%, 0%) scale(1) !important;
//     transform-origin: center center 0;
//     -webkit-font-smoothing: subpixel-antialiased;
//     backface-visibility: hidden;
//     .close-button {
//         right: 26%!important;
//         transform: translate(-50%, -50%) scale(0.7)!important;
//     }
// }
// .hack-game-cotrol-panel,
// .hack-game-status,
// .hack-game-title-wrapper {
//     transform: translate(-50%, -50%) scale(0.7)!important;
//     left: 32.5% !important;
//     top: 2% !important;
// }
//
// .hack-game-status {
//     left: 58.5% !important;
//     top: 66.8% !important;
// }
.hack-game-cotrol-panel {
  transform: translate(-50%, -50%) scale(0.7) !important;
  left: 65.7% !important;
  top: 68.5% !important;
}
</style>
